import { render, staticRenderFns } from "./AlertModalContainer.vue?vue&type=template&id=01aed4e2&"
import script from "./AlertModalContainer.vue?vue&type=script&lang=js&"
export * from "./AlertModalContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports